import { useCallback, useEffect, useRef, useState } from 'react';

import * as BrowserFeatures from '@Stores/BrowserFeatures';
import setCookie from '@Utils/setCookie';
import PopupsStore from '@Stores/Popups';

import type { FC } from 'react';

const params = {
  delay: 30,
  nameInStorage: 'discountTimer',
};

const DiscountSubscriptionPopupTimer: FC = () => {
  const browserFeatures = BrowserFeatures.useBrowserFeaturesStore();
  const timerId = useRef(null);
  const initialValue = browserFeatures.isSessionStorageAvailable
    ? Number(sessionStorage.getItem(params.nameInStorage))
    : null;
  const [timerValue, setTimerValue] = useState(initialValue);

  const cleanup = useCallback(() => {
    clearInterval(timerId.current);
  }, []);

  const handleClose = useCallback(() => {
    setCookie('discount_banner_closed', 'closed', {
      expires: new Date(Date.now() + 60 * 60 * 24 * 7 * 1000), // Время жизни куки - 7 дней
    });
  }, []);

  // Update timer every second
  useEffect(() => {
    timerId.current = setInterval(() => {
      setTimerValue((prev) => prev + 1);
    }, 1000);

    return cleanup;
  }, [cleanup]);

  // Record timer value to storage
  useEffect(() => {
    if (!browserFeatures.isSessionStorageAvailable) return;
    sessionStorage.setItem(params.nameInStorage, timerValue.toString());
  }, [timerValue, browserFeatures.isSessionStorageAvailable]);

  // Check timer value
  useEffect(() => {
    if (timerValue <= params.delay) return;
    if (!browserFeatures.isSessionStorageAvailable) return;
    if (timerValue > params.delay) cleanup();

    PopupsStore.open({ id: 'DiscountSubscribe', data: { onClose: handleClose } });
    sessionStorage.setItem(params.nameInStorage, '0');
    cleanup();
  }, [cleanup, handleClose, timerValue, browserFeatures.isSessionStorageAvailable]);

  return null;
};

export default DiscountSubscriptionPopupTimer;
